import { useEffect, useState, type Dispatch, type SetStateAction } from 'react';

const STORE = 'rolodex.view.';

/** useState that survives leaving the page and coming back in the same tab (sessionStorage), for a
 *  page's filters and view switches. A stored value of a different type than `initial` is ignored, and
 *  without storage (private mode) it is plain state. */
export function useTabState<T>(id: string, initial: T): [T, Dispatch<SetStateAction<T>>] {
  const [value, setValue] = useState<T>(() => {
    try {
      const raw = sessionStorage.getItem(STORE + id);
      if (raw == null) return initial;
      const v = JSON.parse(raw) as unknown;
      return typeof v === typeof initial && (v === null) === (initial === null) ? (v as T) : initial;
    } catch { return initial; }
  });
  useEffect(() => {
    try { sessionStorage.setItem(STORE + id, JSON.stringify(value)); } catch { /* not kept */ }
  }, [id, value]);
  return [value, setValue];
}
